<template>
  <div class="card-block" style="position:relative; top: 75px" @keypress.enter="validateAndSignIn">
    <h2>{{$lang.Login.TitleForm}}</h2>
    <p class="text-muted">{{$lang.Login.TitleFormDescription}}</p>
    <div class="input-group mb-3">
      <span class="input-group-addon"><i class="icon-user"></i></span>
      <b-form-input type="text"
              id="username"
              name="username"
              :placeholder="errorsVee.has('username') ? errorsVee.first('username') : $lang.Login.Username"
              v-model="username"
              v-validate="'required'"
              aria-describedby="usernameErrorFeedback"
              :state="errorsVee.has('username') ? false : getValidationState('username')"
              @blur.native="getValidationState('username')">
      </b-form-input>
    </div>
    <div class="input-group mb-3">
      <span class="input-group-addon"><i class="icon-lock"></i></span>
      <b-form-input :type="showPassword ? 'text' : 'password'"
              class="password__eye__input"
              id="password"
              name="password"
              @input="inputouPassword"
              :placeholder="errorsVee.has('password') ? errorsVee.first('password') : $lang.Login.Password"
              v-model="password"
              data-vv-as="senha"
              v-validate="'required'"
              aria-describedby="passwordErrorFeedback"
              :state="errorsVee.has('password') ? false : getValidationState('password')"
              @blur.native="getValidationState('password')">
      </b-form-input>
        <b-button :class="[showPassword ? 'fas fa-eye-slash' : 'fas fa-eye', typed ? 'password__eye__btn__typed' : ''] " variant="outline-secondary" @click="togglePassword" class="password__eye__btn">
        </b-button>
    </div>
    <div class="row">
      <div class="col-6 text-left">
        <p style="color: #04A791" class="btn btn-link px-0" @click="onresetPassword">{{$lang.Login.LostPassowrd}}</p>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-third px-4" @click="validateAndSignIn"><i class="fas fa-sign-in-alt"></i> {{$lang.Login.ButtonEnter}}</button>
      </div>
    </div>
  </div>
</template>

<script>

import LoginScreen from './login.js'

export default LoginScreen

</script>

<style>
.password__eye__btn{
  border: none;
  border-radius: 0;
  position: absolute;
  right: 0;
  z-index: 5;

  transition: .2s ease-in-out;
}

.password__eye__btn__typed{
  right: 1rem !important;
  transition: .2s ease-in-out;
}

.password__eye__btn:hover, .password__eye__btn:active, .password__eye__btn:focus, .password__eye__btn:focus-visible{
  background: none !important;
  border-left: none !important;
  box-shadow: none;
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/views/public/auth/login/login.vue